import { LogLevel, LoggerProvider } from '@wkda/logger-core';
import { mapLogLevel } from './utils';
const getLoggerFn = logLevel => logLevel === LogLevel.ERROR ? console.error : console.log;
export class ConsoleLoggerProvider extends LoggerProvider {
  constructor(logFormatter) {
    super(logFormatter);
    this.logFormatter = logFormatter;
  }
  getLogger(loggerName) {
    return {
      log: logRecord => {
        return getLoggerFn(logRecord.logLevel ?? 'INFO')({
          level: mapLogLevel(logRecord.logLevel ?? 'INFO'),
          appName: logRecord.meta?.appName,
          appVersion: logRecord.meta?.appVersion,
          stepName: logRecord.meta?.stepName,
          payload: {
            type: logRecord.logger,
            message: logRecord.message,
            stack: logRecord.error?.stackTrace
          }
        });
      },
      name: loggerName
    };
  }
}